import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextAreaInput } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourDescription.graphql'
import { NotificationManager } from 'react-notifications'

class DescriptionForm extends Component {
  state = {
    saving: false
  }

  componentWillMount() {
    this.setState({
      description: this.props.currentSteps.shortDescription || ''
    })
  }

  handleSubmit = values => {
    const { data, updateSteps, updateLocalTour } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        shortDescription: values.shortDescription
      }
    })
      .then(() => {
        this.setState(
          {
            saving: false
          },
          () => {
            NotificationManager.success('Description updated', 'Success', 5000)
            updateSteps()

            if (data.allLocalTours && data.allLocalTours[0]) {
              this.props.history.push(`/activity-steps/${data.allLocalTours[0].id}/photos`)
            } else {
              this.props.history.push('/activity-steps/photos')
            }
          }
        )
      })
      .catch(err => NotificationManager.error('Error while update description', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title create-activity-descr">{t('description')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <TextAreaInput
              id="shortDescription"
              value={this.state.description}
              placeholder={t('short_description_placeholder')}
              initialValue={this.state.description}
              maxChars={300}
              validationFuncs={[validateRequired]}
              label={t('short_description')}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(DescriptionForm)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MainInfo/DescriptionForm.jsx